import { SummaryStatusIcon } from './SummaryStatusIcon'
import { SummaryBox as Container } from './styles'

export function SummaryBox({ children, onClick, active = false, ...rest }) {
  const clickable = typeof onClick === 'function' && !rest.waiting

  const handleKeyDown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onClick(event)
  }

  return (
    <Container
      {...rest}
      data-status={rest.status}
      $clickable={clickable}
      $active={clickable && active}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-pressed={clickable ? active : undefined}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? handleKeyDown : undefined}
    >
      {children}
      <SummaryStatusIcon status={rest.status} />
    </Container>
  )
}
